export class Populations {
  public static Default = 'Default';
  public static TicketTransfer = 'Ticket Transfer';
  public static Paid = 'Paid';
  public static U18 = 'U18';
  public static Digital = 'Digital';
}
